import { z } from 'zod';

export const createVendorInput = z.object({
  name: z.string().min(1).max(120),
  trade: z.string().max(64).nullable().optional(),
  phone: z.string().max(64).nullable().optional(),
  email: z.string().max(128).nullable().optional(),
  website: z.string().max(256).nullable().optional(),
  notes: z.string().max(8000).nullable().optional(),
  status: z.enum(['active', 'archived']).optional(),
});
export type CreateVendorInput = z.infer<typeof createVendorInput>;
export const patchVendorInput = createVendorInput.partial();
export type PatchVendorInput = z.infer<typeof patchVendorInput>;

export const createReferenceInput = z.object({
  domainId: z.string().nullable().optional(),
  title: z.string().min(1).max(200),
  url: z.string().max(2048).nullable().optional(),
  notes: z.string().max(4000).nullable().optional(),
});
export type CreateReferenceInput = z.infer<typeof createReferenceInput>;
export const patchReferenceInput = createReferenceInput.partial();
export type PatchReferenceInput = z.infer<typeof patchReferenceInput>;
